
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { CommonModule } from "@angular/common";
@Pipe({ name: 'SafeFilePipe' })
export class SafeFilePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}



@Pipe({ name: 'SanitizePipe' })
export class SanitizePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    try {
      if (value) {
        switch (type) {
          case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
          case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
          case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
          case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
          case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
          default: throw new Error(`Invalid safe type specified: ${type}`);
        }
      }
    }
    catch (err) {
      return value
    }
  }
}


@Pipe({
  name: "evalPipe",
})
export class evalPipe implements PipeTransform {
  transform(condition, t_id, section, requirement_details?, i?, row_data?, parent_form?, commands_other_data?, form_value?) {
    if (condition) {
      try {


        if (eval(condition)) {
          return true
        }
        else {
          return false
        }
      }
      catch (err) {

        console.error("Invalid Condition")
        return true
      }
    }
    else {
      return true
    }
  }
}



@Pipe({
  name: 'FetchActiveStepsCount'
})
export class FetchActiveStepsCount implements PipeTransform {
  transform(steps) {
    let active_count = 0;
    if (steps) {
      steps.forEach(element => {
        if (element.status >= 1 && element.status <= 3) {
          active_count++;
        }
      });
    }

    return active_count;
  }
}


@Pipe({
  name: "DynamicConditionEval",
})
export class DynamicConditionEval implements PipeTransform {
  transform(val, row, type?) {
    if (!type || type == 1) {
      try {
        if (val) {
          return eval(val);
        }
        else {
          return true
        }
      }
      catch (err) {
        console.log(err)
        return false
      }
    }
    else if (type == 2) {
      try {
        return eval(val)
      }
      catch (Err) {
        return '';
      }
    }
  }
}
